import React, { useCallback, useMemo } from "react";
import cx from "classnames";
import { useTranslate } from "hooks";
import s from "components/ProductConfigurator/ProductConfigurator.module.scss";

import { ModalHolder, type NiceModalHandler } from "@ebay/nice-modal-react";
import { TechnicalDesignModal } from "components/_Modals/TechnicalDesignModal";
import { IconButton } from "components/IconButton/IconButton";
import { useProductOutput } from "stores/product";

export const ExpandableSection = ({
  children,
  title,
  shouldHaveMaximizeBtn = true,
  viewWithTable = false,
  classNames,
}: {
  children:
    | React.ReactNode
    | (({ isInModal }: { isInModal: boolean }) => React.ReactNode);
  title: React.ReactNode;
  shouldHaveMaximizeBtn?: boolean;
  viewWithTable?: boolean;
  classNames?: string;
}) => {
  const technicalDesignModal = useMemo(() => ({}) as NiceModalHandler, []);
  const productOutput = useProductOutput();

  const isProductAccessory =
    !!productOutput?.product?.accessoryInfo?.accessoryId;

  const translate = useTranslate();

  const handleOpenModal = useCallback(() => {
    technicalDesignModal.show();
  }, [technicalDesignModal]);

  return (
    <div className={classNames}>
      <div
        className={cx(
          "d-flex align-items-center justify-content-between",
          s.sectionHeader,
        )}
      >
        <h5 className="text-uppercase text20 mb-0">{title}</h5>
        {shouldHaveMaximizeBtn && (
          <>
            <IconButton
              id="technical-design-header-maximize-btn"
              icon="arrows-maximize-regular"
              className="border-0"
              iconClassName="icon-14"
              data-testid="technical-design-header-arrows-maximize-icon"
              onClick={handleOpenModal}
              tooltipText={translate("MAXIMIZE")}
              disabled={isProductAccessory}
            />
          </>
        )}
        <ModalHolder
          className="h-100"
          modal={TechnicalDesignModal}
          handler={technicalDesignModal}
          viewWithTable={viewWithTable}
        >
          {typeof children === "function"
            ? children({ isInModal: true })
            : children}
        </ModalHolder>
      </div>
      {typeof children === "function"
        ? children({ isInModal: false })
        : children}
    </div>
  );
};
